'use client';
import { useRouter } from 'next/navigation';
import { ROUTES } from '../../constants';

export function useNavigateTo() {
    const router = useRouter();

    return (path: ROUTES | string, queryParams?: string) => {
        const query = queryParams ?? '';
        router.push(path + query);
    };
}
